<template>
<div class="personal-news">
    <div class="card personal-news">
        <div class="card-header bg-black">
            <h3 class="card-title py-1 my-0">{{translate('messages.personal_news')}}</h3>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand"></i>
                </button>
            </div>
        </div>
        <div class="card-body">
            <div v-for="entry in entries" :key="'personal-entry-'+entry.id">
                <div class="text-capitalize pb-2"><i class="far fa-calendar"></i> {{entry.created_at | localDate}}</div>
                <div v-html="entry.content" class="ql-editor p-0"></div>
                <hr>
            </div>
            <div v-if="!loading && !entries.length && !user_interests">
                <p><router-link to="/profile" class="btn btn-sm btn-notiblue">{{translate('messages.let_us_know')}} {{translate('messages.your')}} {{translate('messages.interests')}}</router-link> {{translate('messages.to')}} {{translate('messages.interests_action')}}</p>
            </div>
            <div v-if="!loading && !entries.length && user_interests">
                <p><i class="fas fa-info-circle fa-lg"></i> {{translate('messages.personal_news_soon')}}</p>
            </div>
        </div>
        <div v-if="loading" class="overlay dark">
            <i class="fas fa-sync fa-spin fa-2x"></i>
        </div>
    </div>
</div>
</template>
 
<script>
export default {
    data () {
        return {
            entries : [],
            loading : true,
            user_interests : ''
        }
    },
    methods: {
        loadEntries(){
            axios.get("/api/personalNew/").then(({ data }) => {
                this.entries = data.data; this.loading = false;
            });
        },
        loadUserInterests(){
            axios.get("/api/settings/interests").then(({ data }) => {
                this.user_interests = data.data.interests;
            });
        }
    },
    mounted() {
        $('.ql-editor a').on('click', function(e){
            e.preventDefault();
            let url = $(this).attr('href');
            window.open(url);
        });
    },
    created() {
        this.loadEntries();
        this.loadUserInterests();
    }
}
</script>